import { z } from 'zod';

// Replica las validaciones del portal legacy (DatumCompany): longitudes y regex
// de RUC/DV, mismo formato de teléfono DGI ya usado en EditCompanyPage.
export const newCompanyStep1Schema = z
  .object({
    fullName: z
      .string()
      .min(2, 'Mínimo 2 caracteres')
      .max(150, 'Máximo 150 caracteres')
      .min(1, 'La razón social es requerida'),
    name: z
      .string()
      .min(2, 'Mínimo 2 caracteres')
      .max(50, 'Máximo 50 caracteres')
      .min(1, 'El nombre comercial es requerido'),
    code: z
      .string()
      .min(2, 'Mínimo 2 caracteres')
      .max(50, 'Máximo 50 caracteres')
      .min(1, 'El código es requerido'),
    numberId: z
      .string()
      .min(6, 'Mínimo 6 caracteres')
      .max(25, 'Máximo 25 caracteres')
      .regex(
        /^([A-Z,0-9]+){1,1}$|^([A-Z]*[0-9]+)+?(-[0-9]+){1,4}$|^([0-9]+-)?([A-Z,0-9])+?(-[0-9]+){1,4}$/,
        'Formato de RUC inválido. Ejemplo: 521-136-113133'
      ),
    // DV: solo obligatorio para contribuyente Jurídico (ver superRefine abajo).
    // Para Natural puede quedar vacío; si se completa, igual valida el formato.
    dv: z
      .string()
      .max(4, 'Máximo 4 caracteres')
      .refine((val) => val === '' || /^[0-9]{1,4}$/.test(val), {
        message: 'El DV debe ser numérico. Ejemplo: 02',
      }),
    // Solo requerido (igual que legacy DatumCompany.TypeTaxpayer): el <Select> ya
    // restringe las opciones a '1'/'2', así que no hace falta un refine adicional
    // (evitar refine aquí también previene el auto-narrowing de tipos de TS 5.5+
    // sobre un valor cuyo estado inicial es '').
    typeTaxpayer: z.string().min(1, 'El tipo de contribuyente es requerido'),
    // Teléfono: requerido, igual que el portal legacy (DatumCompany.Phone [Required])
    // y que el BFF (createCompany). Debe respetar el formato DGI.
    phone: z
      .string()
      .min(1, 'El teléfono es requerido')
      .max(16, 'Máximo 16 caracteres')
      .refine(
        (val) => {
          if (!val || val.trim() === '') return true;
          if (val.length < 7 || val.length > 16) return false;
          if (!/^[\d-]+$/.test(val)) return false;
          const digitsOnly = val.replace(/-/g, '');
          return digitsOnly.length >= 7 && digitsOnly.length <= 15;
        },
        { message: 'Formato DGI: 999-9999, 9999-9999 o código-999-9999 (7-16 chars)' }
      ),
    isLimited: z.boolean(),
  })
  .superRefine((values, ctx) => {
    // Jurídico ('2') exige DV, igual que el portal legacy.
    if (values.typeTaxpayer === '2' && values.dv.trim() === '') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'El DV es requerido para contribuyente Jurídico',
        path: ['dv'],
      });
    }
  });

export type NewCompanyStep1FormData = z.infer<typeof newCompanyStep1Schema>;
